import type { FC } from "react";
import { cn } from "@/components/podkit/lib/cn";
import { AWSLogo } from "@/assets/logos/AWSLogo";
import { AzureLogo } from "@/assets/logos/AzureLogo";
import { GCPLogo } from "@/assets/logos/GPCLogo";
import { LinuxLogo } from "@/assets/logos/LinuxLogo";

export const IconStack: FC = () => {
    const className =
        "flex items-center justify-center rounded-lg border-0.5 border-border-light bg-surface-01 shadow-[0_0.6px_0.6px_0px_rgba(0,0,0,0.15)]";
    return (
        <div className="flex h-12 items-center">
            <div className={cn(className, "z-[10] h-12 w-12 p-1.5")}>
                <AWSLogo />
            </div>
            <div className={cn(className, "z-[9] ml-[-8px] h-9 w-9 p-1 grayscale")}>
                <AzureLogo />
            </div>
            <div className={cn(className, "z-[8] ml-[-8px] h-8 w-8 p-0.5 grayscale")}>
                <GCPLogo />
            </div>
            <div className={cn(className, "z-[7] ml-[-8px] h-7 w-7 p-0.5 grayscale")}>
                <LinuxLogo />
            </div>
        </div>
    );
};
